module.exports = __webpack_public_path__ + "img/APEX.d1b70dda.jpg";